"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.view.title': 'Employee Onboarding',
    'onboarding.view.meet': 'Meet',
    'onboarding.view.new_employee': 'Your New AI Employee',
    'onboarding.view.description.1': 'With',
    'onboarding.view.description.2': 'creating and publishing content is a piece of cake.',
    'onboarding.view.description.3': 'In just a few minutes,',
    'onboarding.view.description.4': 'creates content strategy and all content for the coming months.',
    'onboarding.view.has_info': 'has the following information:',
    'onboarding.view.step': 'Step',
    'onboarding.view.step1_info': 'Name, Age, Gender, Voice, Photo',
    'onboarding.view.knowledge': 'Knowledge',
    'onboarding.view.learning_description': 'will learn everything about your company by scanning your website, social media, and other information provided.',
    'onboarding.view.learning_description2': '',
    'onboarding.view.talk_with': 'Talk with',
};
